<app-modal-wrapper
  [title]="model.id ? 'Edit Voucher' : 'New Voucher'"
  [isDirty]="newEditForm?.dirty ?? false"
  [formValid]="newEditForm?.valid ?? false"
  [loading]="initialLoading"
  [showSaveButton]="true"
  [saveLoading]="submitting"
  [keepEditingLabel]="model.id ? 'Keep editing' : 'Keep creating'"
  (save)="newOrSaveRecord()"
  (closeRequest)="ref.close()"
>
  <div modalSkeleton class="flex flex-col gap-4 pt-2">
    <div class="flex flex-col gap-1">
      <p-skeleton width="4rem" height="0.7rem"></p-skeleton>
      <p-skeleton width="100%" height="2.5rem" borderRadius="6px"></p-skeleton>
    </div>
    <div class="flex flex-col gap-1">
      <p-skeleton width="3rem" height="0.7rem"></p-skeleton>
      <p-skeleton width="100%" height="2.5rem" borderRadius="6px"></p-skeleton>
    </div>
    <div class="grid grid-cols-3 gap-4 mt-2">
      <p-skeleton height="3rem" borderRadius="8px"></p-skeleton>
      <p-skeleton height="3rem" borderRadius="8px"></p-skeleton>
      <p-skeleton height="3rem" borderRadius="8px"></p-skeleton>
    </div>
    <div class="flex flex-col gap-1">
      <p-skeleton width="6rem" height="0.7rem"></p-skeleton>
      <p-skeleton width="100%" height="2.5rem" borderRadius="6px"></p-skeleton>
    </div>
  </div>

  <form #newEditForm="ngForm" class="flex flex-col gap-4 pt-2">
    <app-input-text
      label="Name"
      name="name"
      [(ngModel)]="model.name"
      [required]="true"
    ></app-input-text>

    <app-input-dropdown
      label="Type"
      name="voucherTypeId"
      [(ngModel)]="model.voucherTypeId"
      [options]="voucherTypes"
      optionLabel="name"
      optionValue="id"
      placeholder="Select Type"
      [required]="true"
    ></app-input-dropdown>

    <div class="grid grid-cols-3 mt-2 gap-4">

      <div class="flex items-center gap-3  p-3 bg-gray-50 rounded-lg border border-gray-300 hover:bg-gray-100 transition-colors cursor-pointer group"
           (click)="activeCheck.click()">
        <div class="relative flex items-center justify-center w-5 h-5">
          <input
            #activeCheck
            type="checkbox"
            id="isActive"
            name="isActive"
            [(ngModel)]="model.isActive"
            class="peer appearance-none w-5 h-5 border border-gray-300 rounded bg-white checked:bg-[var(--primary-500)] checked:border-[var(--primary-500)] focus:ring-0 focus:ring-offset-0 transition-all cursor-pointer"
            (click)="$event.stopPropagation()"
          />
          <i class="pi pi-check absolute text-white text-[10px] font-bold opacity-0 peer-checked:opacity-100 pointer-events-none transition-opacity duration-200"></i>
        </div>
        <label for="isActive" class="font-bold text-gray-700 text-[13px] cursor-pointer select-none flex-1">
          Active
        </label>
      </div>

      <div class="flex items-center gap-3 p-3 bg-gray-50 rounded-lg border border-gray-300 hover:bg-gray-100 transition-colors cursor-pointer group"
           (click)="commissionCheck.click()">
        <div class="relative flex items-center justify-center w-5 h-5">
          <input
            #commissionCheck
            type="checkbox"
            id="isCommission"
            name="isCommission"
            [(ngModel)]="model.isCommission"
            class="peer appearance-none w-5 h-5 border border-gray-300 rounded bg-white checked:bg-[var(--primary-500)] checked:border-[var(--primary-500)] focus:ring-0 focus:ring-offset-0 transition-all cursor-pointer"
            (click)="$event.stopPropagation()"
          />
          <i class="pi pi-check absolute text-white text-[10px] font-bold opacity-0 peer-checked:opacity-100 pointer-events-none transition-opacity duration-200"></i>
        </div>
        <label for="isCommission" class="font-bold text-gray-700 text-[13px] cursor-pointer select-none flex-1">
          Is Commission
        </label>
      </div>

      <div class="flex items-center gap-3 p-3 bg-gray-50 rounded-lg border border-gray-300 hover:bg-gray-100 transition-colors cursor-pointer group"
           (click)="portTaxCheck.click()">
        <div class="relative flex items-center justify-center w-5 h-5">
          <input
            #portTaxCheck
            type="checkbox"
            id="isPortTax"
            name="isPortTax"
            [(ngModel)]="model.isPortTax"
            class="peer appearance-none w-5 h-5 border border-gray-300 rounded bg-white checked:bg-[var(--primary-500)] checked:border-[var(--primary-500)] focus:ring-0 focus:ring-offset-0 transition-all cursor-pointer"
            (click)="$event.stopPropagation()"
          />
          <i class="pi pi-check absolute text-white text-[10px] font-bold opacity-0 peer-checked:opacity-100 pointer-events-none transition-opacity duration-200"></i>
        </div>
        <label for="isPortTax" class="font-bold text-gray-700 text-[13px] cursor-pointer select-none flex-1">
          Is Authority Tax?
        </label>
      </div>

      <div class="flex items-center gap-3 p-3 bg-gray-50 rounded-lg border border-gray-300 hover:bg-gray-100 transition-colors cursor-pointer group"
           (click)="mustBeRecalculatedCheck.click()">
        <div class="relative flex items-center justify-center w-5 h-5">
          <input
            #mustBeRecalculatedCheck
            type="checkbox"
            id="mustBeRecalculated"
            name="mustBeRecalculated"
            [(ngModel)]="model.mustBeRecalculated"
            class="peer appearance-none w-5 h-5 border border-gray-300 rounded bg-white checked:bg-[var(--primary-500)] checked:border-[var(--primary-500)] focus:ring-0 focus:ring-offset-0 transition-all cursor-pointer"
            (click)="$event.stopPropagation()"
          />
          <i class="pi pi-check absolute text-white text-[10px] font-bold opacity-0 peer-checked:opacity-100 pointer-events-none transition-opacity duration-200"></i>
        </div>
        <label for="mustBeRecalculated" class="font-bold text-gray-700 text-[13px] cursor-pointer select-none flex-1">
          Must be recalculated
        </label>
      </div>

    </div>

    <app-input-dropdown
      label="Default Supplier"
      name="defaultSuplierId"
      [(ngModel)]="model.defaultSuplierId"
      [options]="suppliers"
      optionLabel="name"
      optionValue="id"
      placeholder="No default supplier"
    ></app-input-dropdown>

    <div class="flex flex-col gap-2">
      <div class="flex items-center justify-between">
        <label class="text-[10px] text-gray-500 font-bold uppercase">Default Supplier by Port</label>
        <button
          type="button"
          class="text-xs font-medium text-[var(--primary-500)] hover:underline"
          (click)="addPortDefault()"
        >
          + Add port
        </button>
      </div>

      <div
        *ngFor="let portDefault of model.portDefaultSuppliers; let i = index"
        class="grid grid-cols-[1fr_1fr_auto] gap-2 items-end"
      >
        <app-input-dropdown
          label="Port"
          [name]="'portDefaultPortId' + i"
          [(ngModel)]="portDefault.portId"
          [options]="ports"
          optionLabel="name"
          optionValue="id"
          placeholder="Select Port"
          [required]="true"
        ></app-input-dropdown>

        <app-input-dropdown
          label="Supplier"
          [name]="'portDefaultSuplierId' + i"
          [(ngModel)]="portDefault.suplierId"
          [options]="suppliers"
          optionLabel="name"
          optionValue="id"
          placeholder="Select Supplier"
          [required]="true"
        ></app-input-dropdown>

        <button
          type="button"
          class="pi pi-trash text-red-500 hover:text-red-700 mb-2"
          title="Remove"
          (click)="removePortDefault(i)"
        ></button>
      </div>

      <p *ngIf="hasDuplicatePortDefaults()" class="text-xs text-red-600">
        Each port can only have one default supplier. Remove the duplicate before saving.
      </p>
    </div>

    <app-input-number
      label="External Id"
      type="integer"
      name="code"
      [(ngModel)]="model.code"
      [readonly]="true"
    ></app-input-number>

    <div *ngIf="model.id" class="grid grid-cols-2 gap-4 bg-gray-50 p-4 rounded border border-gray-100 mt-4">
      <div class="flex flex-col gap-1">
        <label class="text-[10px] text-gray-500 font-bold uppercase">Updated In</label>
        <span class="text-xs text-gray-700 font-medium">{{ model?.updatedIn | date: 'dd/MM/yyyy HH:mm' }}</span>
      </div>
      <div class="flex flex-col gap-1">
        <label class="text-[10px] text-gray-500 font-bold uppercase">Updated By</label>
        <span class="text-xs text-gray-700 font-medium">{{ model?.updatedBy }}</span>
      </div>
      <div class="flex flex-col gap-1">
        <label class="text-[10px] text-gray-500 font-bold uppercase">Created In</label>
        <span class="text-xs text-gray-700 font-medium">{{ model?.createdIn | date: 'dd/MM/yyyy HH:mm' }}</span>
      </div>
      <div class="flex flex-col gap-1">
        <label class="text-[10px] text-gray-500 font-bold uppercase">Created By</label>
        <span class="text-xs text-gray-700 font-medium">{{ model?.createdBy }}</span>
      </div>
    </div>

    <app-entity-external-refs-form
      *ngIf="model.id"
      entityType="voucher"
      [entityId]="model.id"
      systemCode="finpac_middleware"
      title="Integrations"
    ></app-entity-external-refs-form>
  </form>
</app-modal-wrapper>
